import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import OwnerPageLayout from '../../components/layout/OwnerPageLayout';
import { getPublicSchoolProfile } from '../../services/marketplaceApi';
import '../../styles/marketplace.css';

export default function PublicSchoolPage() {
    const { slug } = useParams();
    const { t } = useTranslation(['marketplace', 'common']);
    const [school, setSchool] = useState(null);
    const [error, setError] = useState('');

    useEffect(() => {
        getPublicSchoolProfile(slug).then(setSchool).catch(() => setError(t('common:notFound')));
    }, [slug, t]);

    if (error) {
        return (
            <OwnerPageLayout title={t('common:notFound')}>
                <p>{error}</p>
                <Link to="/marketplace">{t('marketplace:title')}</Link>
            </OwnerPageLayout>
        );
    }

    if (!school) {
        return <OwnerPageLayout title={t('common:loading')}><p>{t('common:loading')}</p></OwnerPageLayout>;
    }

    return (
        <OwnerPageLayout title={school.displayName} maxWidth={800} className="mp-page">
            <h1>{school.displayName} {school.isVerified && <span title={t('marketplace:verified')}>✓</span>}</h1>
            <p className="mp-card-location">📍 {[school.city, school.region, school.country].filter(Boolean).join(', ')}</p>
            {school.description && <p style={{ marginTop: 16, lineHeight: 1.6 }}>{school.description}</p>}
            <Link to="/marketplace" className="sp-btn sp-btn--outline" style={{ marginTop: 20 }}>{t('marketplace:title')}</Link>
        </OwnerPageLayout>
    );
}
